import React from "react";
import { useHistory } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;
  const history = useHistory();

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={window.location.origin.startsWith('file') ? 'file:///electron-auth0-redirect' : window.location.origin}
      onRedirectCallback={onRedirectCallback}
      audience={audience}
      scope="permissions"
      //scope="read:dashboard update:dashboard teleop:teleoperation"
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;
